import { TransferenciaListModel } from "model/api/gestao/transferencia/transferencia-list-model"
import { CircularLoading } from "views/components";
import { CardNaoEncontrado } from "views/components/cards";
import { CardTransferencia } from "views/components/cards/card-transferencia/card-transferencia";
import { InformacaoIcon } from "views/components/icons";

interface TransferenciaListDataProps {
    list: TransferenciaListModel[];
    carregando: boolean;
    onCardClick: (model: TransferenciaListModel) => void;
}

export const TransferenciaListData = ({ list, carregando, onCardClick }: TransferenciaListDataProps) => {
    const loading = carregando

    return (
        <>
            {loading && <CircularLoading tipo="FULLSIZED" />}
            {(list.length === 0 && !carregando) && (
                <CardNaoEncontrado icon={<InformacaoIcon tipo="GERAL" />}
                    mensagem="Nenhuma Transferência foi encontrada" />
            )}
            {(list.length > 0 && (
                list.map(transferencia => (
                    <CardTransferencia
                        model={transferencia}
                        onClick={onCardClick} />
                ))
            ))}
        </>
    )
}

